// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intro-box[data-v-0e3dc3d9]{height:calc(100vh - var(--header-height)*2);display:flex;align-items:center;justify-content:center;flex-direction:column}.title[data-v-0e3dc3d9]{margin-bottom:15px;font-size:21px;text-align:center;max-width:600px}.icon-repository[data-v-0e3dc3d9]{font-size:96px;margin-bottom:32px}", ""]);
// Exports
module.exports = exports;
